import { render } from "./BxsSwitchField.vue?vue&type=template&id=0d7c0343&scoped=true"
import script from "./BxsSwitchField.vue?vue&type=script&lang=js"
export * from "./BxsSwitchField.vue?vue&type=script&lang=js"

import "./BxsSwitchField.vue?vue&type=style&index=0&id=0d7c0343&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/vueApps/ronchipiero.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7c0343"]])

export default __exports__